import { AppDispatch } from "../store/store.ts";
import { loadingMessage, showErrorMessage, showLoading } from "../store/slices/alertsSlice.ts";
import * as api from "../api/serviceApi.ts";
import { setAgencyChats, setTwilioToken, setconversationsChats, setStatusAgent, setTemplate, setNotes } from "../store/slices/chatSlice.ts";
import AsyncStorage from '@react-native-async-storage/async-storage';

export const getConversationsChatsAction = () => (dispatch: AppDispatch) => {
  dispatch(showLoading(true));
  dispatch(loadingMessage('Getting Conversations12'));

  api.getConversationsNotJoined().then(result => {
    dispatch(setconversationsChats(result));
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
  }).finally(() => {
    dispatch(showLoading(false));
  });
};

export const getAgencyChatsAction = (jobId: number) => (dispatch: AppDispatch) => {
  dispatch(showLoading(true));
  dispatch(loadingMessage('Getting agencies'));

  api.getAgenciesJob(jobId).then(result => {
    dispatch(setAgencyChats(result.users));
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
  }).finally(() => {
    dispatch(showLoading(false));
  });
};

export const getChat = (chatSID: string, user: string) => (dispatch: AppDispatch) => {
  dispatch(showLoading(true));
  dispatch(loadingMessage('Setting up conversation...'));

  api.postConversationJoin({
    "identity": user,
    "conversation_sid": chatSID
}).then(result => {
   dispatch(showLoading(false));
  })
  .catch(error => {
    dispatch(showErrorMessage(error));
  }).finally(() => {
    dispatch(showLoading(false));
  });
};

export const fetchNewTwilioToken = () => (dispatch: AppDispatch) => {
  console.log('Fetching new twilio token');

  api.getTwilioToken().then(result => {
    dispatch(setTwilioToken(result.token));
    return result.token;
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
  }).finally(() => {
    dispatch(showLoading(false));
  });
}

export const getTwilioTokenAndGo = (user: string, group: number) => (dispatch: AppDispatch) => {
  //dispatch(showLoading(true));
  //dispatch(loadingMessage('Getting conversation token...'));

  return api.postTwilioIdentityToken(user, group).then(async result => { 
    await AsyncStorage.setItem('USER_TOKEN', result.tokens);
    dispatch(setTwilioToken(result.tokens));
    return result.tokens;
  }).then(() => {

  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
  }).finally(() => {
    dispatch(showLoading(false));
  });
};

export const getStatusAgent = (id_channel: string, org_id: string) => (dispatch: AppDispatch) => {
  api.getStatusChannelAgent(id_channel, org_id).then(result => {
    dispatch(setStatusAgent(result.hitl?result.hitl: false));
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error)); 
    dispatch(setStatusAgent(false));
  }).finally(() => {
    //dispatch(showLoading(false));
  });
}

export const getChangeStatusAgent = (body: any) => (dispatch: AppDispatch) => {
  api.postChangeAgent(body).then(result => {
    dispatch(setStatusAgent(result.hitl?result.hitl: false));
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
    dispatch(setStatusAgent(false));
  }).finally(() => {
    //dispatch(showLoading(false));
  });
}

export const createSendMessage = (body: any) => (dispatch: AppDispatch) => {
  api.postSendMessage(body).then(result => {
  }).catch(() => {
  }).finally(() => {
    //dispatch(showLoading(false));
  });
}

export const createSendMedia = (body: any) => (dispatch: AppDispatch) => {
  api.postSendMedia(body).then(result => {
  }).catch(() => {
  }).finally(() => {
    //dispatch(showLoading(false));
  });
}

export const getMediaChat = async (body: any) => {
  return await api.postMediaTwilio(body).then(result => {
    return result
    //dispatch(setMediaChat(result));
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
  }).finally(() => {
    //dispatch(showLoading(false));
  });
}

export const updateChannelAttributes = async (id: string, body: object) => {
  await api.updateAttributes(id, body).then(result => {
    return result;
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
  }).finally(() => {
    //dispatch(showLoading(false));
  });
}

export const updateNameContact = async (body: object) => {
  return await api.renameContact(body).then(result => {
    return result;
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
    return null
  }).finally(() => {
    return null
  });
}

export const getTemplate = (groupId: number) => (dispatch: AppDispatch) => {
  api.getTemplates(groupId).then(result => {
    if(result.length>0){
      const plantillasFormateadas = result.map(obj => {
        const [[sid, body]] = Object.entries(obj); 
        return {
          sid: sid,
          body: body
        };
      });
      dispatch(setTemplate(plantillasFormateadas));
    }
  }).catch(() => {
  }).finally(() => {
    //return null;
  })
}

export const sendTemplate = (id: string, body: object, close: event)  => (dispatch: AppDispatch)=> {
  api.postTemplate(id, body).then(result => {
    return result;
  }).catch(() => {
  }).finally(() => {
    close()
    return null;
  })
}

export const postAssign = async (id: string, body: object) => {
  return await api.postAssignUser(id, body).then(result => {
    return result;
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
    return null
  }).finally(() => {
    return null
  });
}

export const postNotes = async (id: string, body: object) => {
  return await api.updateNotes(id, body).then(result => {
    return result;
  }).catch(() => {
    //content msg error
    //dispatch(showErrorMessage(error));
    return null
  }).finally(() => {
    return null
  });
}

export const getNotes = (sid: string, orgId: number, whatsapp: string) => async (dispatch: AppDispatch) => {
  await api.getNotes(sid, orgId.toString(), encodeURIComponent(whatsapp)).then(result => {
    if(result.status == "ok"){
      dispatch(setNotes(result.notes));
    }
  }).catch(() => {
    dispatch(setNotes(""));
  }).finally(() => {
    //return null;
  })
}
